import Vue from 'vue'
import Router from 'vue-router'
import pcRoutes from './pcRoutes'
import tabletRoutes from './tabletRoutes'
import deviceType from '../utils/deviceType'
import VXETable from 'vxe-table'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/sign-up',
      name: 'SignUp',
      meta: {
        title: 'SignUp',
        isSidebar: false
      },
      component: () => import('@/views/SignUp')
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: 'Login',
        isSidebar: false
      },
      component: () => import('@/views/Login')
    },
    {
      path: '/projects/',
      name: 'Projects',
      meta: {
        title: '專案列表',
        isSidebar: false
      },
      component: () => import('@/views/Projects')
    },
    {
      path: '/403',
      name: '403',
      meta: {
        title: '403'
      },
      component: () => import('@/views/404')
    },
    {
      path: '*',
      name: '404',
      meta: {
        title: '404'
      },
      redirect: {name: 'Login'},
      component: () => import('@/views/404')
    },
    {
      path: '/systemMaintenance',
      name: '503',
      meta: {
        title: '系統維護中'
      },
      component: () => import('@/views/systemMaintenance')
    },
    {
      path: '/registerByGoogle',
      name: 'RegisterByGoogle',
      meta: {
        title: '綁定 Google Login'
      },
      component: () => import('@/views/RegisterByGoogle') },

    {
      path: '/invitation-handler/:invitationId',
      name: 'InvitationHandler',
      meta: {
        title: '邀請至專案 處理程序'
      },
      component: () => import('@/views/Invitation.vue')
    }
  ]
})

if (!deviceType.isPC) {
  tabletRoutes.forEach(route => router.addRoute(route))
} else {
  pcRoutes.forEach(route => router.addRoute(route))
}

router.onReady(() => {
  // 判斷當前裝置的型號從而改變當前路由
  router.app.$store.commit('setDeviceType', deviceType)
})

router.beforeEach(async (to, from, next) => {
  await Vue.nextTick()
  if (to.name !== null) {
    if (to.meta.isSidebar || to.meta.isSidebar === undefined) { // 如果有sidebar
      if (to.meta.sideBarCatalog !== 'main' && deviceType.isPC) {
        router.app.$store.commit('project/setCurrent', null)
      }
      router.app.$store.commit('modules/setModuleList', to.meta.sideBarCatalog)
      router.app.$store.commit('modules/setCurrentFunction', to.name)
    } else {
      router.app.$store.commit('modules/setModuleList', undefined)
    }
  } else next()
  if (to.name === 'Login' || to.name === '404' || to.name === 'BugReport' || to.name === 'SuggestReport' || to.name === '503' || to.name === '403') {
    next()
  } else if (to.name === 'SignUp' || to.name === 'InvitationHandler') {
    next()
  } else {
    if (!router.app.$store.state.user.authenticated) {
      let authentication = await router.app.$store.dispatch('user/authentication')
      if (authentication.status) {
        router.app.$store.commit('user/setAuthenticated', true)
        router.app.$store.commit('user/setCurrent', authentication.data)
        next()
      } else {
        await VXETable.modal.alert({
          status: 'error',
          content: '您的權限過期或是沒有權限。',
          title: '🙏請重新登入！',
          confirmButtonText: '好',
          draggable: false
        })
        router.replace({name: 'Login', query: {redirect: to.fullPath}})
        next()
      }
    } else next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js